// weddingRenderer.ts
import { EnvironmentRenderer } from '../../utils/environmentRenderer';
// Décor de Noël pour le niveau mariage

export class WeddingBackgroundRenderer {
  drawBackground(ctx: CanvasRenderingContext2D, cameraX: number, canvasWidth: number, canvasHeight: number): void {
    // Ciel bleu pâle avec neige (harmonisé avec les autres niveaux)
    // Utilise la méthode utilitaire pour le dégradé
    // (import au top du fichier)
    EnvironmentRenderer.drawSkyGradient(ctx, cameraX, canvasWidth, canvasHeight, '#eaf6ff', '#b3d0e6');

    // Flocons de neige (inchangé)
    for (let i = 0; i < 80; i++) {
      const x = (i * 97 + cameraX * 0.7) % canvasWidth
      const y = (i * 53) % canvasHeight
      ctx.beginPath()
      ctx.arc(x, y, 1.5 + (i % 2), 0, Math.PI * 2)
      ctx.fillStyle = 'rgba(255,255,255,0.7)'
      ctx.fill()
    }

    // Sapins en arrière-plan (harmonisé avec les autres niveaux)
    EnvironmentRenderer.drawRepeatingElements(ctx, cameraX, canvasWidth, [
      {
        spacing: 110,
        offset: 0,
        drawFunction: (ctx: CanvasRenderingContext2D, x: number) => this.drawPineTree(ctx, x, canvasHeight - 120, 1.2)
      },
      {
        spacing: 85,
        offset: 0,
        drawFunction: (ctx: CanvasRenderingContext2D, x: number) => this.drawPineTree(ctx, x, canvasHeight - 80, 0.7)
      }
    ]);
  }

  drawGround(ctx: CanvasRenderingContext2D, cameraX: number, canvasWidth: number, canvasHeight: number): void {
    // Harmonisation avec Paris/Venise/PSG : sol décoratif uniquement, pas de rectangle supplémentaire
    EnvironmentRenderer.drawTexturedGround(
      ctx,
      cameraX,
      canvasWidth,
      360, // Y fixe comme les autres niveaux
      40,
      '#fff',
      '#b3d0e6',
      8
    );
  }

  drawPineTree(ctx: CanvasRenderingContext2D, x: number, y: number, scale: number = 1): void {
    ctx.save()
    ctx.translate(x, y)
    ctx.scale(scale, scale)
    // Tronc
    ctx.fillStyle = '#8B5C2A'
    ctx.fillRect(-3, 20, 6, 18)
    // Branches (3 triangles)
    ctx.fillStyle = '#1e5631'
    for (let i = 0; i < 3; i++) {
      ctx.beginPath()
      ctx.moveTo(0, i * 10)
      ctx.lineTo(-18 + i * 3, 30 + i * 2)
      ctx.lineTo(18 - i * 3, 30 + i * 2)
      ctx.closePath()
      ctx.fill()
    }
    // Neige pixel art sur les branches (petits rectangles)
    ctx.fillStyle = '#fff'
    ctx.fillRect(-8, 20, 16, 3) // neige sur la branche du bas
    ctx.fillRect(-7, 13, 14, 3) // neige sur la branche du milieu
    ctx.fillRect(-5, 7, 10, 2)  // neige sur la branche du haut
    ctx.restore()
  }
}


// Dessin d'un bonhomme de neige (obstacle)
export function drawGift(ctx: CanvasRenderingContext2D, x: number, y: number, width: number = 24, height: number = 24) {
  ctx.save();
  // Corps (3 boules)
  ctx.fillStyle = '#fff';
  ctx.beginPath();
  ctx.arc(x + width / 2, y + height - 7, 8, 0, Math.PI * 2); // base
  ctx.arc(x + width / 2, y + height - 18, 6, 0, Math.PI * 2); // ventre
  ctx.arc(x + width / 2, y + height - 26, 4, 0, Math.PI * 2); // tête
  ctx.fill();
  // Yeux
  ctx.fillStyle = '#222';
  ctx.beginPath();
  ctx.arc(x + width / 2 - 1.5, y + height - 27, 0.8, 0, Math.PI * 2);
  ctx.arc(x + width / 2 + 1.5, y + height - 27, 0.8, 0, Math.PI * 2);
  ctx.fill();
  // Nez carotte
  ctx.strokeStyle = '#ff9900';
  ctx.beginPath();
  ctx.moveTo(x + width / 2, y + height - 25.5);
  ctx.lineTo(x + width / 2 + 3, y + height - 25);
  ctx.stroke();
  // Boutons
  ctx.fillStyle = '#444';
  for (let i = 0; i < 2; i++) {
    ctx.beginPath();
    ctx.arc(x + width / 2, y + height - 15 - i * 5, 0.7, 0, Math.PI * 2);
    ctx.fill();
  }
  // Chapeau
  ctx.fillStyle = '#222';
  ctx.fillRect(x + width / 2 - 4, y + height - 31, 8, 3);
  ctx.fillRect(x + width / 2 - 2, y + height - 35, 4, 5);
  // Bras (branches)
  ctx.strokeStyle = '#8B5C2A';
  ctx.lineWidth = 1.2;
  ctx.beginPath();
  ctx.moveTo(x + width / 2 - 6, y + height - 18);
  ctx.lineTo(x + width / 2 - 13, y + height - 23);
  ctx.moveTo(x + width / 2 + 6, y + height - 18);
  ctx.lineTo(x + width / 2 + 13, y + height - 23);
  ctx.stroke();
  ctx.restore();
}
